/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, { FC, useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap-v5'
// import { useIntl } from 'react-intl'
import { AsideMenuItem } from '../../../_metronic/layout/components/aside/AsideMenuItem'
import { AsideMenuMain } from '../../../_metronic/layout/components/aside/AsideMenuMain'
import { MenuItem } from '../../../_metronic/layout/components/header/MenuItem'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  MixedWidget2,
  MixedWidget8,
  MixedWidget10,
  MixedWidget11,
  // ListsWidget2,
  // ListsWidget3,
  // ListsWidget4,
  // ListsWidget5,
  // ListsWidget6,
  // TablesWidget5,
  // TablesWidget10,

} from '../../../_metronic/partials/widgets'
import { TwoY_AxisChart } from '../../../_metronic/partials/widgets/chartsComponents/TwoY_AxisChart'
import DashboardComponent from './components/DashboardComponent'


const DashboardPage = () => {






  return (
    <>
      <DashboardComponent />
    </>
  )
}


const DashboardWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        Dashboard
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
